import graphql__2e8df03b4efb58b14597 from "./__generated__/CommentsPanel_commentable.graphql.js";
import graphql__568bdfcec3e98df94dc8 from "./__generated__/CommentsPanelPaginationQuery.graphql.js";import { Component } from "react";
import { createPaginationContainer } from "react-relay";
import { graphql } from "react-relay";
import { injectIntl, defineMessages } from "react-intl";
import classNames from "classnames";
import padStart from "lodash/padStart";

import Button from "../Buttons/Button";
import CommentsList from "./CommentsList";
import { withCommentForm } from "../GeneralServices/CommentFormService";
import InfinitelyScrollableContainer from "../Utils/InfinitelyScrollableContainer";
import { Mobile, Default } from "../Utils/ResponsiveQueries";
import Icon from "../Utils/Icon";
import { isUnauthorized } from "../Utils/authorizations";

class CommentsPanel extends Component {
  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this);
    this.onMoreCommentsLoaded = this.onMoreCommentsLoaded.bind(this);

    this.state = {};
  }

  get labels() {
    const { formatMessage } = this.props.intl;

    return {
      title: formatMessage(intlMessages.title),
      addComment: formatMessage(intlMessages.addComment),
      loadMore: formatMessage(intlMessages.loadMore)
    };
  }

  get commentButton() {
    if (isUnauthorized(this.props.commentable.authorizations.submitComment)) return null;

    return (
      <Button
        className="btn btn-primary btn-md"
        onClick={this.props.showCommentForm}
        label={this.labels.addComment}
        iconClassName="icon-arrow-right"
        iconPosition="after"
        data-comment-button
      />
    );
  }

  get commentsNodes() {
    return this.props.commentable.comments.edges.map(edge => edge.node);
  }

  get commentsList() {
    return <CommentsList comments={this.commentsNodes} />;
  }

  get commentsCount() {
    return padStart(this.props.commentable.commentsCount, 2, "0");
  }

  get hasMoreCommentsToLoad() {
    return this.props.commentable.comments && this.props.relay.hasMore();
  }

  get loadMoreButton() {
    if (!this.hasMoreCommentsToLoad) return null;

    return (
      <button
        className="margin-md btn btn-primary comments-load-more"
        onClick={this.loadMore}
        disabled={this.isLoading}
        data-loading={this.isLoading}
      >
        {this.labels.loadMore}
      </button>
    );
  }

  get isLoading() {
    return this.state.status === "loading";
  }

  get commentPanelTitleBar() {
    const { commentsCount, commentButton, labels } = this;
    const hasComments = commentsCount > 0;

    const commentPanelTitleBarClassName = classNames("comments-title", "padding-x-md", {
      "padding-bottom-sm": hasComments
    });

    return (
      <div className={commentPanelTitleBarClassName}>
        <div className="d-flex align-items-center">
          <h2 className="comments-panel-title text-title-page padding-right-sm">
            {labels.title}
          </h2>

          <div className="comments-count margin-left-sm text-metric-sm with-icon">
            <span className="with-icon-text">{commentsCount}</span>
            <Icon className="icon-contribute text-primary margin-left-xs" />
          </div>

          <Default>
            <div className="ml-auto">{commentButton}</div>
          </Default>
        </div>

        <Mobile>
          <div className="margin-top-xs">{commentButton}</div>
        </Mobile>
      </div>
    );
  }

  loadMore() {
    if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
      return;
    }

    this.props.relay.loadMore(10, this.onMoreCommentsLoaded);
    this.setState({ status: "loading" });
  }

  onMoreCommentsLoaded() {
    this.setState({ status: "responseReceived" });
  }

  render() {
    return (
      <div className="box comments">
        {this.commentPanelTitleBar}

        <InfinitelyScrollableContainer
          className="comment-list-scrollable-container margin-x-md"
          onBottomReached={this.loadMore}
        >
          {this.commentsList}
        </InfinitelyScrollableContainer>

        {this.loadMoreButton}
      </div>
    );
  }
}

export default injectIntl(
  withCommentForm(
    createPaginationContainer(
      CommentsPanel,
      {
        commentable: graphql__2e8df03b4efb58b14597
      },

      {
        direction: "forward",

        getConnectionFromProps(props) {
          return props.commentable && props.commentable.comments;
        },

        getFragmentVariables(prevVars, totalCount) {
          return {
            ...prevVars,
            commentsCount: totalCount
          };
        },

        getVariables(props, { count, cursor }) {
          return {
            commentsCount: count,
            commentsCursor: cursor,
            commentableId: props.commentable.id
          };
        },

        query: graphql__568bdfcec3e98df94dc8
      }
    )
  )
);

const intlMessages = defineMessages({
  title: {
    id: "comments.panel.title",
    defaultMessage: "Commentaires"
  },
  addComment: {
    id: "comments.form.addComment",
    defaultMessage: "Ajouter un commentaire"
  },
  loadMore: {
    id: "comments.form.loadMore",
    defaultMessage: "Voir plus de commentaires ..."
  }
});
